module.exports = __webpack_public_path__ + "static/bu-logo-8eff841c830634d40059697434882688.png";